import { Link } from 'react-router-dom';
import { COMPANY } from '../data/seedData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-800 text-sm mt-auto">
      {/* Main Footer Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1: About & Logo */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src={COMPANY.logo}
                alt="RB Glasfiber A/S Logo"
                className="h-14 sm:h-16 w-auto object-contain brightness-105"
              />
            </Link>
            <p className="text-slate-300 text-xs sm:text-sm leading-relaxed">
              RB Glasfiber er specialist i udførsel og reparation af glasfiberopgaver. Vi fremstiller pumpebrønde, indstøbningsbrønde, tanke, overdækninger og kundetilpassede specialopgaver.
            </p>
            <div className="pt-2 text-xs text-slate-400 space-y-1">
              <div>CVR: <span className="text-slate-200 font-mono">{COMPANY.cvr}</span></div>
              <div>Virksomhed: <span className="text-slate-200">{COMPANY.name}</span></div>
            </div>
          </div>

          {/* Col 2: Produkter & Løsninger */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-xs mb-4 flex items-center gap-2">
              <span className="w-1.5 h-3 bg-[#1e9457] rounded-xs"></span>
              Produkter & Løsninger
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/rb-glasfiber/pumpebronde-amp-tanke" className="hover:text-white transition-colors">
                  Pumpebrønde & tanke
                </Link>
              </li>
              <li>
                <Link to="/produkter/glasfiber-containere" className="hover:text-white transition-colors">
                  Glasfiber containere
                </Link>
              </li>
              <li>
                <Link to="/produkter/iglo-amp-fancy" className="hover:text-white transition-colors">
                  Iglo & fancy containere
                </Link>
              </li>
              <li>
                <Link to="/produkter/batteribokse" className="hover:text-white transition-colors">
                  Batteribokse (RB 10 & RB 30)
                </Link>
              </li>
              <li>
                <Link to="/produkter/sand-salt-containere" className="hover:text-white transition-colors">
                  Sand-salt containere
                </Link>
              </li>
              <li>
                <Link to="/rb-glasfiber/overdaekning" className="hover:text-white transition-colors">
                  Roterende overdækning
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Ydelser & Viden */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-xs mb-4 flex items-center gap-2">
              <span className="w-1.5 h-3 bg-[#1e9457] rounded-xs"></span>
              Kompetencer & Info
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/rb-glasfiber/reparationer" className="hover:text-white transition-colors">
                  Udkørende reparation
                </Link>
              </li>
              <li>
                <Link to="/rb-glasfiber/specialopgaver" className="hover:text-white transition-colors">
                  Specialopgaver i glasfiber
                </Link>
              </li>
              <li>
                <Link to="/referencer" className="hover:text-white transition-colors">
                  Dokumenterede referencer
                </Link>
              </li>
              <li>
                <Link to="/information/ce-godkendelser" className="hover:text-white transition-colors">
                  CE Godkendelser & Certifikater
                </Link>
              </li>
              <li>
                <Link to="/information/samarbejdspartnere" className="hover:text-white transition-colors">
                  Samarbejdspartnere
                </Link>
              </li>
              <li>
                <Link to="/handelsbetingelser" className="hover:text-white transition-colors">
                  Salgs- & leveringsbetingelser
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Kontakt information */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-xs mb-4 flex items-center gap-2">
              <span className="w-1.5 h-3 bg-[#1e9457] rounded-xs"></span>
              Kontakt & Lokation
            </h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#1e9457] mt-1"></i>
                <div>
                  <div className="text-slate-200 font-medium">RB Glasfiber A/S</div>
                  <div>Jernvej 6, Mønsted</div>
                  <div>8800 Viborg</div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#1e9457]"></i>
                <a
                  href={`tel:${COMPANY.phoneRaw}`}
                  className="text-slate-200 hover:text-white font-semibold transition-colors whitespace-nowrap"
                >
                  {COMPANY.phone}
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-[#1e9457]"></i>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-slate-300 hover:text-white transition-colors whitespace-nowrap"
                >
                  {COMPANY.email}
                </a>
              </div>

              <div className="pt-2">
                <div className="text-xs text-slate-400">Daglig ledelse:</div>
                <div className="text-slate-200 font-medium">{COMPANY.contactPerson}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Legal / Copyright Bar */}
      <div className="border-t border-slate-900 bg-slate-950 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div>
            © {currentYear} RB Glasfiber A/S · CVR: {COMPANY.cvr} · Alle rettigheder forbeholdes.
          </div>
          <div className="flex items-center gap-4">
            <Link to="/handelsbetingelser" className="hover:text-slate-300 transition-colors">
              Salgs- og leveringsbetingelser
            </Link>
            <span>·</span>
            <Link to="/kontakt" className="hover:text-slate-300 transition-colors">
              Kontakt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
